export const SOFA_SCORE = {
  masterTableName: "MC_SOFA_SCORE",
  tableName: "MC_SOFA_SCORE_DET",
  columnName: "SS_ID",
  columnValue: 0,
  title: "sofa-score.title",
  rows: [
    { title: "id", value: "ID" },
    { title: "date", value: "PROCESS_TIME", headerName: "Tarih", type: "date" },
    { title: "CUSER", value: "CUSER" },
    { title: "RESPIRATORY", value: "RESPIRATORY_XNAME" },
    { title: "COAGULATION", value: "COAGULATION_XNAME" },
    { title: "LIVER", value: "LIVER_XNAME" },
    { title: "CARDIOVASCULAR", value: "CARDIOVASCULAR_XNAME" },
    { title: "CENTRAL_NERVOUS_SYSTEM", value: "CENTRAL_NERVOUS_SYSTEM_XNAME" },
    { title: "RENAL_CREATININE", value: "RENAL_CREATININE_XNAME" },
    { title: "RENAL_URINE_OUTLET", value: "RENAL_URINE_OUTLET_XNAME" },
    { title: "RESULT", value: "RESULT" },
    { title: "NURSE_NOTE", value: "NURSE_NOTE" },
  ],
  fields: [
    { field: "date", headerName: "datetime", flex: 1 },
    { field: "CUSER", headerName: "createdby", flex: 1 },
    { field: "RESPIRATORY", headerName: "sofa-score.respiratory", flex: 1 },
    { field: "COAGULATION", headerName: "sofa-score.coagulation", flex: 1 },
    { field: "LIVER", headerName: "sofa-score.liver", flex: 1 },
    { field: "CARDIOVASCULAR", headerName: "sofa-score.cardiovascular", flex: 1 },
    { field: "CENTRAL_NERVOUS_SYSTEM", headerName: "sofa-score.central-nervous-system", flex: 1 },
    { field: "RENAL_CREATININE", headerName: "sofa-score.renal-creatinine", flex: 1 },
    { field: "RENAL_URINE_OUTLET", headerName: "sofa-score.renal-urine-outlet", flex: 1 },
    {
      field: "RESULT",
      headerName: "score",
      flex: 1,
      computed: true,
      calculate: (row: any) => {
        if (!row) return 0;
        const respiratory = Number(row.RESPIRATORY_XVALUE) || 0;
        const coagulation = Number(row.COAGULATION_XVALUE) || 0;
        const liver = Number(row.LIVER_XVALUE) || 0;
        const cardiovascular = Number(row.CARDIOVASCULAR_XVALUE) || 0;
        const centralNervousSystem = Number(row.CENTRAL_NERVOUS_SYSTEM_XVALUE) || 0;
        const renalCreatinine = Number(row.RENAL_CREATININE_XVALUE) || 0;
        const renalUrineOutlet = Number(row.RENAL_URINE_OUTLET_XVALUE) || 0;

        return respiratory + coagulation + liver + cardiovascular + centralNervousSystem + renalCreatinine + renalUrineOutlet;
      },
    },
    { field: "NURSE_NOTE", headerName: "note", flex: 1 },
  ],
  mcpConfig: {
    RESPIRATORY: { mcpId: 270, field: "RESPIRATORY", scoreField: "RESPIRATORY_XVALUE" },
    COAGULATION: { mcpId: 271, field: "COAGULATION", scoreField: "COAGULATION_XVALUE" },
    LIVER: { mcpId: 272, field: "LIVER", scoreField: "LIVER_XVALUE" },
    CARDIOVASCULAR: { mcpId: 273, field: "CARDIOVASCULAR", scoreField: "CARDIOVASCULAR_XVALUE" },
    CENTRAL_NERVOUS_SYSTEM: { mcpId: 274, field: "CENTRAL_NERVOUS_SYSTEM", scoreField: "CENTRAL_NERVOUS_SYSTEM_XVALUE" },
    RENAL_CREATININE: { mcpId: 275, field: "RENAL_CREATININE", scoreField: "RENAL_CREATININE_XVALUE" },
    RENAL_URINE_OUTLET: { mcpId: 276, field: "RENAL_URINE_OUTLET", scoreField: "RENAL_URINE_OUTLET_XVALUE" },
  } as Record<string, { mcpId: number; field: string; scoreField: string }>,
  formData: {
    SS_ID: "",
    PROCESS_TIME: new Date(),
    CTIME: new Date(),
    CUSER: "",
    NURSE_ID: "",
    RESPIRATORY: "",
    COAGULATION: "",
    LIVER: "",
    CARDIOVASCULAR: "",
    CENTRAL_NERVOUS_SYSTEM: "",
    RENAL_CREATININE: "",
    RENAL_URINE_OUTLET: "",
    RESULT: 0,
    NURSE_NOTE: "",
  },
  chartScoreField: "RESULT",
  chartTimeField: "PROCESS_TIME",
};
